import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { CheckboxField, CheckboxFieldProps } from '../Fields/CheckboxField';

export default function CheckboxFieldController<T extends FieldValues>({
  name,
  onChange,
  disabled,
  ...props
}: CheckboxFieldProps & { name: Path<T> }) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<T>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <CheckboxField
          checked={Boolean(field.value)}
          disabled={disabled || isSubmitting}
          onChange={(event, checked) => {
            field.onChange(event);
            onChange?.(event, checked);
          }}
          error={fieldState.error}
          {...props}
        />
      )}
    />
  );
}
